// extracted by mini-css-extract-plugin
export default {"container":"Tag_container__S++a6","tags-wrapper":"Tag_tags-wrapper__fUey8"};